import { BookkeepingItemType } from '../enums/bookkeepingItemType'
import { BookkeepingItem } from '../types/bookkeepingItem'

const typeToXfModelMap: Record<BookkeepingItemType, string> = {
  [BookkeepingItemType.Bill]: 'Xf\\Model\\AbstractBill',
  [BookkeepingItemType.Invoice]: 'Xf\\Model\\AbstractInvoice',
  [BookkeepingItemType.ExternalInvoice]: 'Xf\\Model\\ExternalInvoice',
  [BookkeepingItemType.Posting]: 'Xf\\Model\\Posting',
}

export const convertBookkeepingItemsToReconciliationSubjects = (items: BookkeepingItem[]): string[] => {
  return items.map((item) => {
    const modelPrefix = typeToXfModelMap[item.type]
    return `${modelPrefix}:${item.id}`
  })
}
